module.exports = __webpack_public_path__ + "img/regroup-icon.646b717d.svg";